import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { STATUS_API } from 'src/app/constant/config';
import { Formik } from 'formik';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import { updateDeviceDisplayName } from 'src/features/deviceSlice';

function AddDisplayNameModal({ open, onClose, device, onSuccess }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const statusUpdate = useSelector(state => state.deviceSlice.statusUpdate);

  const handleSubmit = async values => {
    await dispatch(
      updateDeviceDisplayName({
        id: device.id,
        data: {
          name: values.name?.trim(),
          enable: Boolean(values.name?.trim())
        }
      })
    );

    onSuccess?.();
    onClose();
  };

  return (
    <CustomDialog title="Tên gợi nhớ phương tiện" open={open} onClose={onClose}>
      <Formik
        initialValues={{
          license_plate: device?.vehicle?.license_plate || '',
          name: device?.name || ''
        }}
        enableReinitialize
        validationSchema={Yup.object().shape({
          name: Yup.string()
            .max(100, 'Tên gợi nhớ tối đa 100 ký tự')
        })}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <InputLabel>
                  Tên / Biển số
                </InputLabel>
                <TextField
                  fullWidth
                  disabled
                  margin="normal"
                  className="input-no-fieldset"
                  name="license_plate"
                  size="small"
                  value={values.license_plate}
                  variant="outlined"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <InputLabel>
                  Tên gợi nhớ
                </InputLabel>
                <TextField
                  fullWidth
                  margin="normal"
                  className="input-no-fieldset"
                  name="name"
                  size="small"
                  placeholder=""
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.name}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Box my={3}>
              <div className={classes.groupButtonSubmit}>
                <div className={classes.wrapper}>
                  <Button
                    style={{
                      ...(isMobile && { maxWidth: 90 }),
                      marginRight: '10px'
                    }}
                    onClick={onClose}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                  >
                    Thoát
                  </Button>

                  <Button
                    style={{
                      ...(isMobile && { maxWidth: 120 }),
                      marginRight: '10px'
                    }}
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    disabled={statusUpdate === STATUS_API.PENDING}
                  >
                    Lưu lại
                  </Button>

                  {statusUpdate === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </div>
            </Box>
          </form>
        )}
      </Formik>
    </CustomDialog>
  );
}

const useStyles = makeStyles(theme => ({
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px'
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

export default React.memo(AddDisplayNameModal);
